// extracted by mini-css-extract-plugin
module.exports = {"blue_btn":"_3K7MIDjlhyIEqjH063z2p9"};